import styled from 'styled-components';

import { gutter, rowGap } from './system';
import { ResponsiveValue } from '../../types';

export const Container = styled.div<{
  gutter: ResponsiveValue;
  rowGap: ResponsiveValue;
}>`
  flex-flow: row wrap;
  display: flex;
  ${rowGap};
  ${gutter};
`;
